import { RemixBrowser } from '@remix-run/react'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { getInitialNamespaces } from 'remix-i18next/client'
import i18n from './utils/i18n.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

async function hydrate() {
	await i18next
		.use(initReactI18next)
		.use(LanguageDetector)
		.use(Backend)
		.init({
			...i18n,
			ns: getInitialNamespaces(),
			backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
			detection: {
				// Server sets <html lang>; client trusts that so SSR and hydration match.
				order: ['htmlTag'],
				caches: [],
			},
		})

	startTransition(() => {
		hydrateRoot(
			document,
			<I18nextProvider i18n={i18next}>
				<RemixBrowser />
			</I18nextProvider>,
		)
	})
}

if (window.requestIdleCallback) {
	window.requestIdleCallback(() => void hydrate())
} else {
	// Safari doesn't support requestIdleCallback
	window.setTimeout(() => void hydrate(), 1)
}
